import {type FunctionalComponent, h} from '@stencil/core';
import {type SearchTableColumnConfiguration, type SortableHeader, SortOrder } from '../SearchTableConfiguration';

export interface SearchTableHeaderProps{
    columns: SearchTableColumnConfiguration[],
    labelProvider: CallableFunction,
    sortColumn: CallableFunction,
    sortTableHeader: Array<SortableHeader>,
    theme: string
}

export const SearchTableHeaders:FunctionalComponent<SearchTableHeaderProps> = (props) => {
    const labelProvider = props.labelProvider;
    const columns = props.columns;
    const sortColumn = props.sortColumn;
    const sortTableHeader = props.sortTableHeader;
    const theme = props.theme;
    return <tr class="search-table-header-group">
      {columns.map(column => header(column, labelProvider, sortColumn, sortTableHeader, theme))}
    </tr>;
};

function header(column: SearchTableColumnConfiguration, labelProvider, sortColumn, sortTableHeader, theme){
    return <th class={`search-table-header ${column.left ? '' : '-margin-left'}`} style={{ 'padding-left': column.left ? column.left : '', 'width': column.width, 'font-weight': column.headerNotBold ? '400' : '700' }}
      onClick={() => sortColumn(column.fieldName)}>
      <span>
        <span innerHTML={labelProvider(column.title, column.title)} class='search-table-header-item'/>
        {column.sortable ? <uiaas-search-table-header-sorting
          sortOrder={column.sortOrder ? column.sortOrder : SortOrder.None}
          headerName={column.fieldName}
          sortTableHeader={sortTableHeader}
          theme={theme}
        ></uiaas-search-table-header-sorting>
          : ''}
      </span>
    </th>;
}
